import { numberMoney } from 'Data/format.js'
import { getAdjustedTreatmentFeeBeforeInsurances } from 'Data/payment-plan.js'

export function getValue(payment_plan, estimated_reimbursement_amount) {
  let treatment_fee = getAdjustedTreatmentFeeBeforeInsurances(payment_plan)
  return numberMoney(treatment_fee - estimated_reimbursement_amount)
}
